import React, { useEffect, useState } from 'react';
import {
  Container,
  Row,
  Col,
  Navbar,
  NavbarBrand,
  Button,
  Nav,
  NavItem,
  NavLink,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  Card,
  CardBody
} from 'reactstrap';
import '../assets/css/App.css';
import logo from "../assets/images/logoh.png";
import { useTranslation } from 'react-i18next';
import { FaBarcode, FaBoxes, FaChevronDown, FaShoppingCart, FaTachometerAlt, FaUndoAlt, FaUserCircle, FaBox, FaShoppingBag } from 'react-icons/fa';
import { FaUser, FaSignOutAlt } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';
import { authActions } from '../sagas/authSlice';
import { BARCODE_PAGE, INVENTORY_PAGE, REFUND_PAGE, PRODUCTS_PAGE, SALES_PAGE, STOCK_PAGE, DASHBOARD_PAGE, PROFILE_PAGE, PURCHASES_PAGE } from '../routes/routeConstants';
import { saleActions } from '../sagas/saleSlice';
import { purchaseActions } from '../sagas/purchaseSlice';

const Layout = ({ children }) => {
  const role = useSelector((state) => state.auth.role);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    Swal.fire({
      title: t('auth.logoutConfirmTitle'),
      text: t('auth.logoutConfirmText'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#dc3545',
      cancelButtonColor: '#6c757d',
      confirmButtonText: t('common.confirm'),
      cancelButtonText: t('common.cancel')
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(purchaseActions.clearCart());
        dispatch(saleActions.clearCart());
        dispatch(authActions.logout());
        Swal.fire({
          icon: 'success',
          title: t('auth.logoutSuccess'),
          showConfirmButton: false,
          timer: 1500
        }).then(() => {
          navigate('/login');
        });
      }
    });
  };

  const menuItems = role && role === 'ROLE_ADMIN' ? [
    { path: DASHBOARD_PAGE, icon: FaTachometerAlt, label: t('nav.dashboard') },
    { path: PRODUCTS_PAGE, icon: FaBox, label: t('nav.products') },
    { path: PURCHASES_PAGE, icon: FaShoppingBag, label: t('nav.purchases') },
    { path: SALES_PAGE, icon: FaShoppingCart, label: t('nav.sales') },
    { path: STOCK_PAGE, icon: FaBoxes, label: t('nav.stock') },
    { path: BARCODE_PAGE, icon: FaBarcode, label: t('nav.barcodes') },
    { path: REFUND_PAGE, icon: FaUndoAlt, label: t('nav.refund') },
    { path: INVENTORY_PAGE, icon: FaBoxes, label: t('nav.inventory') },
    { path: PROFILE_PAGE, icon: FaUser, label: t('nav.profile') },
    { path: '/logout', icon: FaSignOutAlt, label: t('nav.signOut'), action: handleLogout },
  ] : [
    { path: PRODUCTS_PAGE, icon: FaBox, label: t('nav.products') },
    { path: PURCHASES_PAGE, icon: FaShoppingBag, label: t('nav.purchases') },
    { path: SALES_PAGE, icon: FaShoppingCart, label: t('nav.sales') },
    { path: REFUND_PAGE, icon: FaUndoAlt, label: t('nav.refund') },
    { path: PROFILE_PAGE, icon: FaUser, label: t('nav.profile') },
    { path: '/logout', icon: FaSignOutAlt, label: t('nav.signOut'), action: handleLogout },
  ];

  return (
    <div className="app-wrapper d-flex flex-column min-vh-100">
      {/* Header */}
      {/* <header>
        <Navbar className="navbar-light bg-white border-bottom px-4" expand="lg">
          <NavbarBrand href="/" className="d-flex align-items-center">
            <img
              src={logo}
              alt="MatjarPos"
              height="45"
              className="brand-logo"
            />
          </NavbarBrand>

          <div className="business-name flex-grow-1 text-center">
            <h4 className="mb-0 fw-bold">{businessName}</h4>
          </div>
          <div className="ms-auto d-flex align-items-center">
            <UncontrolledDropdown>
              <DropdownToggle nav className="d-flex align-items-center text-dark">
                <div className="d-flex align-items-center">
                  <FaUserCircle size={20} className="me-2" />
                  <span className="me-1">{fullName}</span>
                  <FaChevronDown size={12} />
                </div>
              </DropdownToggle>
              <DropdownMenu end className="shadow-sm">
                <DropdownItem header>
                  <small className="text-muted">
                    {t('user.signedInAs')} <br />
                    <strong>{fullName}</strong>
                  </small>
                </DropdownItem>
                <DropdownItem divider />
                <DropdownItem onClick={() => navigate('/profile')}>
                  <FaUser className="me-2" /> {t('user.profile')}
                </DropdownItem>
                <DropdownItem divider />
                <DropdownItem onClick={handleLogout}>
                  <FaSignOutAlt className="me-2" /> {t('user.signOut')}
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </div>
        </Navbar>
      </header> */}

      <div className="content-wrapper d-flex flex-grow-1">
        {/* Menu Cards */}
        <aside className="menu-cards-container bg-light border-end p-3" style={{ width: '250px' }}>
          {menuItems.map((item) => (
            <Card
              key={item.path}
              className={`mb-2 menu-card ${location.pathname === item.path ? 'active' : ''}`}
              onClick={() => item.action ? item.action() : navigate(item.path)}
            >
              <CardBody className="d-flex align-items-center">
                <item.icon size={20} className="me-2" />
                <span>{item.label}</span>
              </CardBody>
            </Card>
          ))}
        </aside>

        {/* Main Content */}
        <main className="main-content flex-grow-1 bg-light">
          <Container fluid className="p-4">
            {children}
          </Container>
        </main>
      </div>

      {/* Footer */}
      <footer className="footer bg-white border-top py-3">
        <Container fluid className="px-4">
          <Row className="align-items-center">
            <Col md={6} className="text-start">
              <span className="text-muted">MatjarPos v1.0</span>
            </Col>
            <Col md={6} className="text-end">
              <span className="text-muted">© {new Date().getFullYear()} IDERACLOUD. All rights reserved.</span>
            </Col>
          </Row>
        </Container>
      </footer>
    </div>
  );
};

export default Layout;